<div id="toolbar">
  <p-toolbar class="rounded-none h-18 bg-[#F3F3F3]">
    <ng-template #start>
      <div onKeyUp class="flex items-center pl-5" (click)="openSidebar()">
        <i class="pi pi-bars cursor-pointer" style="font-size: 1.4rem"></i>
      </div>
    </ng-template>

    <ng-template #center>
      <div class="flex items-center gap-2" routerLink="/home">
        <img
          class="h-10 w-auto"
          src="./assets/icons/Logo qualitambiente.svg"
          alt="Qualitambiente"
        />
      </div>
    </ng-template>

    <ng-template #end>
      <div class="flex items-center pr-5" routerLink="/home">
        <i
          class="pi pi-home text-3xl cursor-pointer"
          style="color: #1e7f88; font-size: 1.6rem"
        ></i>
      </div>
    </ng-template>
  </p-toolbar>
</div>

<p-drawer
  [(visible)]="visibleSidebar2"
  position="left"
  [appendTo]="mainPage()"
  styleClass="mobile-sidebar"
>
  <!-- Header Template -->
  <ng-template pTemplate="header">
    <div class="flex items-center w-full h-32 bg-[#F3F3F3]">
      <div class="flex gap-2 ml-7">
        <p-avatar
          [label]="(authStore.user()?.name)![0]"
          [style]="{
            width: '38px',
            height: '38px',
            'border-radius': '50%',
            color: 'white',
            background: '#1e7f88',
          }"
        />
        <div class="flex flex-col gap-1">
          <span class="text-xl font-semibold mb-1">
            {{ authStore.user()?.name }}
          </span>
          @if (clienteName() && cantiereName()) {
            <span class="text-sm! align-center font-medium">
              <i class="pi pi-user text-gray text-sm mr-1"></i>
              {{ clienteName() | titlecase }}
            </span>
            <span class="text-sm! align-center font-medium">
              <i class="pi pi-map-marker text-gray text-sm mr-1"></i>
              {{ cantiereName() | titlecase }}
            </span>
          }
        </div>
      </div>

      <button
        class="bg-teal-600 hover:bg-teal-700 border-none rounded w-8 h-8 flex items-center justify-center cursor-pointer transition-all duration-200"
        (click)="closeSidebar()"
      >
        <i class="pi pi-times text-white text-sm"></i>
      </button>
    </div>
  </ng-template>

  <!-- Content Template -->
  <ng-template pTemplate="content">
    <nav class="flex flex-col h-full overflow-y-auto">
      @for (route of sideNavRoutesToShow(); track $index; let last = $last) {
        @if (!last) {
          <div
            onKeyUp
            class="nav-item flex items-center pl-7 pr-2 py-6 cursor-pointer transition-all duration-200 text-gray-500 no-underline border-none bg-none w-full hover:bg-gray-50 hover:text-teal-600"
            [routerLink]="route.path"
            routerLinkActive="nav-item-active"
            (click)="closeSidebar()"
          >
            @if (route.img.includes('.svg')) {
              <img [src]="route.img" class="mr-2"/>
            } @else {
              <i class="pi pi-{{ route.img }} text-lg!  mr-3 ml-2 text-gray-400 transition-colors duration-200"></i>
            }
            <span class="text-lg! font-normal text-gray-700 capitalize">
              {{ route.title | translate }}
            </span>
          </div>
        }
      }

      <div
        onKeyUp
        class="nav-item flex items-center pl-7 pr-2 py-6 cursor-pointer transition-all duration-200 text-gray-500 no-underline border-none bg-none w-full hover:bg-gray-50 hover:text-teal-600 mt-auto"
        [routerLink]="['/guida-supporto']"
        routerLinkActive="nav-item-active"
        (click)="closeSidebar()"
      >
        <i class="pi pi-question-circle text-lg! mr-3 ml-2 text-gray-400 transition-colors duration-200"></i>
        <span class="text-lg! font-normal text-gray-700 capitalize">
          {{ "Guida & Supporto" | translate }}
        </span>
      </div>
    </nav>
  </ng-template>

  <!-- Footer Template -->
  <ng-template pTemplate="footer">
    @for (route of sideNavRoutesToShow(); track $index; let last = $last) {
      @if (last) {
        <div
          onKeyUp
          class="nav-item logout-item flex items-center px-4 py-3 cursor-pointer transition-all duration-200 no-underline border-none bg-none w-full border-t border-gray-200 text-red-600 hover:bg-red-50 mb-3"
          (click)="logout()"
        >
          <i class="pi pi-{{ route.img }} text-lg mr-3 text-red-600"></i>
          <span class="text-lg! text-red-600">
            {{ route.title | translate }}
          </span>
        </div>
      }
    }

    <!-- Version Info -->
    <div
      class="bg-gray-200 py-1 text-center absolute bottom-0 left-0 right-0 w-full"
    >
      <small class="block text-gray-700">
        Versione sistema: {{ version }}
      </small>
    </div>
  </ng-template>
</p-drawer>
